export default "__VITE_PUBLIC_ASSET__6af3325e__"